
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Select,
    InputNumber
} from '../../ui/ot'
import { useTranslation } from "react-i18next";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
const AuthorisedCategoryValueForm = ({
    keyPrefix = 'koha.authorized_category_values_management',
    propsForm,
    field,
    formReloadCount = 0,
    libraryOption,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {}
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_;
    const [count, setCount] = useState(0);
    const editor = useRef(null);
    const [show, setShow] = useState(true)
    const { t } = useTranslation('translation', { keyPrefix })

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
        // propsOnValuesChange(formValues)
    };

    const setFieldValue = (name, value) => {

        form.setValue(name, value);
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;

        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        let formValues = null;

        formValues = form.getFieldsValue();
    }, [formReloadCount]);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                form={form}
                                keyPrefix={keyPrefix}
                                field={field}
                                // initialValues={initialValues}
                                show={show}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}
                                libraryOption={libraryOption}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    keyPrefix,
    field,
    initialValues = {},
    show,
    getAnyFormValue,
    count,
    setFieldValue,
    setCount,
    libraryOption,
    form
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const TINYINT_CATEGORIES = ['DAMAGED', 'LOST', 'NOT_LOAN', 'RESTRICTED', 'WITHDRAWN'];
    const data = Form.useWatch(field?.name ? [field?.name ?? '', 'category'].join('.') : 'category', form)

    useEffect(() => {
        if (!libraryOption) {
            libraryController?.getData({})
        }
    }, [])
    return (
        <>
            <Row>
                <Col
                    span={24}
                >
                    <Form.Item
                        labelCol={4}
                        wrapperCol={20}
                        {...field}
                        name={[field?.name ?? '', 'id']}
                        fieldKey={[field?.fieldKey ?? '', 'id']}
                    >
                        <div></div>
                    </Form.Item>
                </Col>
                <Col
                    span={
                        24
                    }
                >
                    <Form.Item
                        labelCol={4}
                        wrapperCol={20}
                        {...field}
                        name={[field?.name ?? '', 'category']}
                        fieldKey={[field?.fieldKey ?? '', 'category']}
                        label={t('category')}
                        rules={[
                            {
                                required: true,
                                message: t("required_field"),
                            },
                        ]}
                    >
                        <Input disabled />
                    </Form.Item>
                </Col>
                {TINYINT_CATEGORIES.includes(getAnyFormValue([field?.name ?? '', 'category'].join('.'))) ?
                    (<Col span={24} >
                        <Form.Item
                            labelCol={4}
                            wrapperCol={20}
                            {...field}
                            name={[field?.name ?? '', 'authorised_value']}
                            fieldKey={[field?.fieldKey ?? '', 'authorised_value']}
                            label={t('authorized_values')}
                            rules={[
                                {
                                    required: true,
                                    message: t("required_field"),
                                },
                            ]}
                        >
                            <Input type="number" min={1} max={255} />
                        </Form.Item>
                    </Col>) :
                    (<Col span={24} >
                        <Form.Item
                            labelCol={4}
                            wrapperCol={20}
                            {...field}
                            name={[field?.name ?? '', 'authorised_value']}
                            fieldKey={[field?.fieldKey ?? '', 'authorised_value']}
                            label={t('authorized_values')}
                            rules={[
                                {
                                    required: true,
                                    message: t("required_field"),
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>)
                }
                <Col span={24} >
                    <Form.Item
                        labelCol={4}
                        wrapperCol={20}
                        {...field}
                        name={[field?.name ?? '', 'lib']}
                        fieldKey={[field?.fieldKey ?? '', 'lib']}
                        rules={[
                            {
                                required: true,
                                message: t("required_field"),
                            },
                        ]}
                        label={t('description')}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={24} >
                    <Form.Item
                        labelCol={4}
                        wrapperCol={20}
                        label={t('description_opac')}
                        name={[field?.name ?? '', 'lib_opac']}
                        fieldKey={[field?.fieldKey ?? '', 'lib_opac']}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col
                    span={24}
                >
                    <Form.Item
                        labelCol={4}
                        wrapperCol={20}
                        label={t('library_limitations')}
                        name={[field?.name ?? '', 'branches']}
                        fieldKey={[field?.fieldKey ?? '', 'branches']}
                        allowClear={true}
                    >
                        <Select
                            allowClear={true}
                            mode={"multiple"}
                            options={libraryOption ? libraryOption : libraryController?.ResponseData?.map((value) => {
                                return {
                                    label: value?.branchname,
                                    value: value?.branchcode,
                                }
                            })}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};


export default AuthorisedCategoryValueForm;
